import TextAction from "./TextAction";
import textActionTypography from "./textActionTypography";

export { TextAction as default, textActionTypography };
